import {
  BooleanFilterDTO,
  DateFilterDTO,
  FilterBooleanOptionDTO,
  FilterDateRangeOptionDTO,
  FilterNumberRangeOptionDTO,
  FilterStringOptionDTO,
  FloatFilterDTO,
  PaginatedResultDTO,
  QueryDTO,
  sortDirection,
  StringFilterDTO,
} from './generated';

export function buildQueryParams<T extends QueryDTO>(params: T): string {
  return JSON.stringify(params);
}

export function blobToDataURL(blob: Blob): Promise<string> {
  const reader = new FileReader();
  return new Promise((resolve, reject) => {
    reader.onload = () => {
      resolve(reader.result as string);
    };
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
}

export interface Paginated<T> extends PaginatedResultDTO {
  data: T[];
}

export interface SortDTO<T> {
  sortField: keyof T;
  sortDirection: sortDirection;
}

export type FilterDTO = Record<string, StringFilterDTO | DateFilterDTO | FloatFilterDTO | BooleanFilterDTO>;

export type FilterOptionsDTO = Record<
  string,
  Array<FilterStringOptionDTO> | FilterBooleanOptionDTO | FilterDateRangeOptionDTO | FilterNumberRangeOptionDTO
>;

export interface ICapturerEvents extends Record<string, any> {
  capture_start_at: string;
  type: EventTypes;
}

export type EventTypes =
  | 'activity_started'
  | 'activity_ended'
  | 'datapoint_uploaded'
  | 'stitching_finished'
  | 'license_plate_read'
  | 'classification_finished';
